var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProgressBar } from '.';
import { useToast } from '../hooks/useToast';
import { isFunction, SetCssBackgroundColorTransition } from '../utils';
import { useTheme } from '../../../themes';
import * as S from '../styles';
import CloseMark from '../../../assets/icons/CloseMark';
import { BREAKPOINTS, useBreakpoint } from '../../../hooks';
export var Toast = function (props) {
    var _a = useToast(props), isRunning = _a.isRunning, preventExitTransition = _a.preventExitTransition, toastRef = _a.toastRef, eventHandlers = _a.eventHandlers;
    var hasCloseButton = props.hasCloseButton, autoClose = props.autoClose, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn, title = props.title, icon = props.icon, description = props.description, transitionBgColor = props.transitionBgColor, rest = __rest(props, ["hasCloseButton", "autoClose", "type", "hideProgressBar", "closeToast", "transition", "position", "className", "style", "bodyClassName", "bodyStyle", "progressClassName", "progressStyle", "updateId", "rtl", "toastId", "deleteToast", "isIn", "title", "icon", "description", "transitionBgColor"]);
    var customColors = {
        bgColor: rest.bgColor,
        bColor: rest.bColor,
        bgIconColor: rest.bgIconColor,
        progressBarColor: rest.progressBarColor,
        colorScheme: rest.colorScheme,
        titleColor: rest.titleColor,
        descriptionColor: rest.descriptionColor,
    };
    var cssClasses = isFunction(className)
        ? className({
            rtl: rtl,
            position: position,
            type: type,
        })
        : className;
    var stardustTheme = useTheme();
    var breakpoint = useBreakpoint();
    var currentTitle = title;
    if (breakpoint === BREAKPOINTS.SM) {
        currentTitle = title || description;
    }
    var bg = SetCssBackgroundColorTransition({ bg: transitionBgColor, isIn: isIn });
    return (_jsx(Transition, __assign({ isIn: isIn, done: deleteToast, position: position, preventExitTransition: preventExitTransition, nodeRef: toastRef }, { children: _jsx(S.TostWrapper, __assign({ style: bg }, { children: _jsxs(S.Toast, __assign({ id: toastId, className: cssClasses }, eventHandlers, { style: style, type: type, ref: toastRef, rtl: rtl }, customColors, { children: [_jsx("span", { children: icon }), _jsxs("span", __assign({ dir: rtl ? 'rtl' : '', className: isFunction(bodyClassName)
                            ? bodyClassName({ type: type })
                            : bodyClassName, role: "status", style: bodyStyle, "aria-atomic": "true" }, { children: [_jsx("div", __assign({ id: "toast-title" }, { children: currentTitle })), description && _jsx("div", __assign({ id: "toast-description" }, { children: description }))] })), hasCloseButton && (_jsx("button", __assign({ onClick: function (e) {
                            e.stopPropagation();
                            closeToast();
                        }, "aria-label": "close" }, { children: _jsx(CloseMark, { "aria-hidden": "true", fill: stardustTheme.neutrals.gray6 }) }))), _jsx(ProgressBar, __assign({}, (updateId ? { key: "pb-".concat(updateId) } : {}), { rtl: rtl, delay: autoClose, isRunning: isRunning, isIn: isIn, closeToast: closeToast, hide: hideProgressBar, type: type, style: progressStyle, className: progressClassName, controlledProgress: !autoClose }, customColors))] })) })) })));
};
